import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-alert',
  imports: [CommonModule],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
})
export class AlertComponent {
  private alertService = inject(AlertService);

  alert$ = this.alertService.alert$;

  closeAlert() {
    this.alertService.clearAlert();
  }
}
